/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

export abstract class SecureService {
  client: AxiosInstance;

  constructor(config?: AxiosRequestConfig) {
    let isRefreshing = false;
    let failedQueue: any = [];

    const processQueue = (error: any | null, token: string | null) => {
      failedQueue.forEach((prom: any) => {
        if (error) {
          prom.reject(error);
        } else {
          prom.resolve(token);
        }
      });
      failedQueue = [];
    };

    this.client = axios.create(config);
    this.client.interceptors.request.use((iConfig) => {
      const nConfig = iConfig;
      if (localStorage.apikey)
        nConfig.headers = {
          ...nConfig.headers,
          'x-api-key': localStorage.apikey,
        };
      if (localStorage.accessToken)
        nConfig.headers = {
          ...nConfig.headers,
          Authorization: `Bearer ${localStorage.accessToken}`,
        };
      return nConfig;
    });
    this.client.interceptors.response.use(
      (response) => {
        if (response.data && response.data.success === false) {
          // Créer une erreur avec les infos du backend
          const error: any = new Error(response.data.message || 'Backend error');
          error.response = {
            status: response.data.status || 500,
            data: response.data,
            statusText: response.data.message || 'Backend Error',
            headers: response.headers,
            config: response.config,
          };

          // Rejeter comme si c'était une vraie erreur HTTP
          return Promise.reject(error);
        }
        return response;
      },
      async (error) => {
        const originalRequest = error.config;

        if (!error.response) {
          console.error('Erreur réseau:', error);
          return Promise.reject(error);
        }

        if (
          error.response.status === 401 ||
          (error.response.status === 406 && !originalRequest._retry)
        ) {
          if (isRefreshing) {
            try {
              const token = await new Promise((resolve, reject) => {
                failedQueue.push({ resolve, reject });
              });
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return await axios(originalRequest);
            } catch (err) {
              return Promise.reject(err);
            }
          }

          originalRequest._retry = true;
          isRefreshing = true;

          const { refreshToken } = localStorage;

          if (!refreshToken) {
            window.location.pathname = '/login';
            return Promise.reject(new Error('No refresh token'));
          }

          return new Promise((resolve, reject) => {
            axios
              .post(`${process.env.VUE_APP_API_URL}auth/refresh`, { refreshToken })
              .then(({ data }) => {
                localStorage.setItem('accessToken', data.accessToken);
                originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
                processQueue(null, data.accessToken);
                resolve(axios(originalRequest));
              })
              .catch((err) => {
                processQueue(err, null);
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                window.location.pathname = '/login';
                reject(err);
              })
              .finally(() => {
                isRefreshing = false;
              });
          });
        }
        return Promise.reject(error);
      },
    );
  }
}
